import { render } from "./CustomButton.vue?vue&type=template&id=576cbb5a&scoped=true&ts=true"
import script from "./CustomButton.vue?vue&type=script&lang=ts"
export * from "./CustomButton.vue?vue&type=script&lang=ts"

import "./CustomButton.vue?vue&type=style&index=0&id=576cbb5a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/owt/owt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576cbb5a"]])

export default __exports__